import { styled } from '@mui/system'

export const StyledDownload = styled('button')(({ theme }) => ({
    textDecoration: 'underline',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
    color: theme.palette.success.main
}))
